// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton__backButton--QnRX8","backIcon":"BackButton__backIcon--yaYnZ"};